"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timedOut = void 0;
const tslib_1 = require("tslib");
const sleep_1 = require("./sleep");
const timedOut = (mainPromise, timeout, onTimeoutFallback) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const maxTimeoutSymbol = Symbol('Timeout');
    const result = yield Promise.race([mainPromise, (0, sleep_1.sleep)(timeout).then(() => maxTimeoutSymbol)]);
    if (result === maxTimeoutSymbol) {
        return onTimeoutFallback();
    }
    return result;
});
exports.timedOut = timedOut;
//# sourceMappingURL=timedOut.js.map